export enum TransferType {
  Source = 'source',
  Destination = 'destination',
}
